import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FieldReference, FieldReferenceService } from '../../services/field-reference.service';
import { Observable, Subject, debounceTime, distinctUntilChanged, filter, map, merge } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-field-reference-input',
  templateUrl: './field-reference-input.component.html',
  styleUrl: './field-reference-input.component.scss'
})
export class FieldReferenceInputComponent {
  fieldReferences: FieldReference[] = [];
  @Input()
  entity: string = '';
  @Input()
  selectedPath: string = '';
  @Output()
  selectedPathChange = new EventEmitter<string>();
  freeText: boolean = false;
  noFieldReference: boolean = false;

  constructor(protected fieldReferenceService: FieldReferenceService, protected translate: TranslateService) { }


  ngOnInit() {
      this.fieldReferenceService.getFieldReferences(this.entity).pipe(
            map(fields => fields.map(field => {
              field.displayName = this.translate.instant(field.name) + " (" + field.path + ")";
              field.selected = false;

              if (this.selectedPath && field.path === this.selectedPath) {
                field.selected = true;
              }

              return field;
            }))
          ).subscribe((data: FieldReference[]) => {
      this.fieldReferences = data;

      if (this.selectedPath && !this.fieldReferences.find(f => f.path === this.selectedPath)) {
        this.freeText = true;
      }

      if (this.fieldReferences.length === 0) {
        this.noFieldReference = true;
      }
    });
  }
  
  onSelect(selected: FieldReference) {
    const selectedId: string = selected[0];
    const fieldReference = this.fieldReferences.find(f => f.id === selectedId);

    if (fieldReference) {
      this.selectedPath = fieldReference.path;
      this.selectedPathChange.emit(this.selectedPath);
    } else {
      console.warn('Could not find field reference with id:', selectedId);
      this.selectedPath = '';
      this.selectedPathChange.emit(this.selectedPath);
    }
  }
}
